module.exports = __webpack_public_path__ + "static/media/memories_9.12671600.jpg";